export default {
  /**
   * Updates the user's current locale
   * @param {string} locale en, es, fr
   */
  updateLocale: async ({ commit }, locale) => {
    commit('SET_LOCALE', locale)
  },
}
